import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Loader } from '../../Elements/Loader';
import { StyledInput } from '../common/StyledInput';
import StyledInputContainer from '../common/StyledInputContainer';
import useHoverAndFocusState from '../hooks/useHoverAndFocusState';
import { IconContainer, InputWrapper, MaxLengthContainer } from './styled';
// exports
export { default as TextField } from './TextField';
export { default as InputRenderer } from './InputRenderer';
const Input = React.forwardRef(function Input({ isLoading, maxLength, value, type, icon, isActionIcon, error, warning, success, dataTestId, ...props }, ref) {
    const { colors } = useTheme();
    const [{ focused, hovered }, { ...hoverAndFocusProps }] = useHoverAndFocusState({
        onBlurHandler: props.onBlur,
        onFocusHandler: props.onFocus,
        onMouseEnterHandler: props.onMouseEnter,
        onMouseLeaveHandler: props.onMouseLeave,
    });
    const handleWheel = useCallbackRef((e) => {
        if (type === 'number') {
            e.target.blur();
        }
    });
    const memoizedIconClick = React.useMemo(() => (React.isValidElement(icon) && 'onClick' in icon.props ? icon.props.onClick : undefined), [icon]);
    const memoizedIconContent = React.useMemo(() => React.isValidElement(icon) ? React.cloneElement(icon, { onClick: undefined }) : icon, [icon]);
    return (_jsxs(StyledInputContainer, { inputFocused: focused, inputHovered: hovered, inputDisabled: props.disabled, error: error, warning: warning, success: success, "data-testid": dataTestId, children: [_jsxs(InputWrapper, { children: [_jsx(StyledInput, { onWheel: handleWheel, maxLength: maxLength, value: value, ref: ref, withIcon: isLoading || (!!icon && !maxLength), type: type, ...props, ...hoverAndFocusProps }), isLoading && (_jsx(IconContainer, { children: _jsx(Loader, { fill: colors.grey100_1, background: 'transparent' }) })), icon && !isLoading && !maxLength && (_jsx(IconContainer, { isActionIcon: isActionIcon, onClick: memoizedIconClick, children: memoizedIconContent }))] }), maxLength && (_jsxs(MaxLengthContainer, { isDisabled: props.disabled, children: [value?.length || 0, "/", maxLength] }))] }));
});
export default Input;
